export default __webpack_public_path__ + "static/media/banner-video.123e4b8a.mp4";